
import Component from "vue-class-component";
import Vue from "vue";
import BarcodeCompanyModule  from "@/store/modules/barcodeSystem/barcodeCompany";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { CompanyResource, CompanyListItem } from "../../models/api/barcodeSystem/barcodeCompanies/get";
import { EditBarcodeCompanyModel } from "@/models/ui/editBarcodeCompany";
import { formatBool } from "@/utils";

const barcodeCompanyModuleState = getModule(BarcodeCompanyModule);
import notifications from "../../lib/notifications";
import { CompanyFacilityResource } from "@/models/api/barcodeSystem/barcodeCompanies/facilities";
import { CompanyManufacturerResource } from "@/models/api/barcodeSystem/barcodeCompanies/manufacturers";
import { CompanyItemTypeResource } from "@/models/api/barcodeSystem/barcodeCompanies/itemTypes";
import { CompanyBillToResource } from "@/models/api/barcodeSystem/barcodeCompanies/billTos";
@Component({
  components: {
    Select
  }
})
export default class BarcodeCompanies extends Vue {
  companies: CompanyListItem[] = null;
  companyFilter: string = null;
  loading: boolean = false;
  editCompanyModel: EditBarcodeCompanyModel = null;
  promptDelete: boolean = false;
  currentCompany: CompanyListItem = null;
  facilityCode: string = null;
  manufacturerCode: string = null;
  itemTypeValue: string = null;
  billToCompanyId: string = null;
  companyFacilities: Array<CompanyFacilityResource> = null;
  companyManufacturers: Array<CompanyManufacturerResource> = null;
  companyItemTypes: Array<CompanyItemTypeResource> = null;
  companyBillTos: Array<CompanyBillToResource> = null;
  showManageFacilities: boolean = false;
  showManageManufacturers: boolean = false;
  showManageItemTypes: boolean = false;
  showManageBillTos: boolean = false;
  showAddModal: boolean = false;

  async created() {
    await this.loadCompanies();
  }

  async loadCompanies() {
    this.loading = true;
    await barcodeCompanyModuleState.loadCompanies();
    this.companies = barcodeCompanyModuleState.companies;
    this.loading = false;
  }

  get filteredCompanies() {
    if(this.companyFilter)
      return this.companies.filter(x =>x.companyName && x.companyName.toUpperCase().startsWith(this.companyFilter.toUpperCase()));
    else
      return this.companies;
  }

  formatBool(val: string)
  {
    return formatBool(val);
  }

  companyNameState() {
    return this.editCompanyModel.companyName ? null : false;
  }

  facilityCodeState() {
    return this.facilityCodeState ? null : false;
  }

  validateForm() {
    if(this.companyNameState() === false) return false;
    return true;
  }

  goBack() {
    this.$router.back();
  }

  async saveCompany() {
    if(!this.validateForm()) return;
    try {
      this.editCompanyModel.saving = true;
      if (this.editCompanyModel.isNew) {
        await barcodeCompanyModuleState.createCompany(this.editCompanyModel.toCreateCompanyRequest());
      } else {
        await barcodeCompanyModuleState.updateCompany(this.editCompanyModel.toUpdateCompanyRequest());
      }
      notifications.success("Company Saved", "Successfully saved company");
      await this.loadCompanies();
      this.closeEditCompanyModal();
    } catch (ex) {
      notifications.error("Save Company", "Failed to save company", ex);
      this.editCompanyModel.saving = false;
    }
  }  
  
  async deleteCompany() {
    try {
      this.editCompanyModel.saving = true;
      if (!this.editCompanyModel.isNew) {
        await barcodeCompanyModuleState.deleteCompany(this.editCompanyModel.id);
      }
      notifications.success("Company Deleted", "Successfully deleted company");
      await this.loadCompanies();
      this.closeEditCompanyModal();
    } catch (ex) {
      notifications.error("Delete Company", "Failed to delete company", ex);
      this.editCompanyModel.saving = false;
    }
  }

  async manageFacilities(company: CompanyListItem) {
    try {
      this.loading = true;
      this.companyFacilities = null;
      this.currentCompany = company;     
      this.showManageFacilities = true;
      this.companyFacilities =  await barcodeCompanyModuleState.getCompanyFacilities(this.currentCompany.id);
    } catch (ex) {
      notifications.error("Company Facilities", "Failed to load company facilities", ex);
      this.showManageFacilities = false;
    } finally {
      this.loading = false;
    }
  }

  closeManageModals(){
    this.closeAddModal();
    this.closeDeleteModal();
    this.showManageFacilities = false;
    this.showManageItemTypes = false;
    this.showManageBillTos = false;
    this.showManageManufacturers = false;
  }

  async removeFacility() {
    try {
      this.loading = true;
      await barcodeCompanyModuleState.removeCompanyFacilityCode({id: this.currentCompany.id, facilityCode: this.facilityCode});
      this.companyFacilities =  await barcodeCompanyModuleState.getCompanyFacilities(this.currentCompany.id);
      notifications.success("Facility Removed", "Successfully removed facility");
      this.facilityCode = null;
      this.closeDeleteModal();
    } catch (ex) {
      notifications.error("Remove Facility", "Failed to remove facility", ex);
    } finally {
      this.loading = false;
    }
  }

  async addFacility() {
    try {
      this.loading = true;
      await barcodeCompanyModuleState.addCompanyFacilityCode({id: this.currentCompany.id, facilityCode: this.facilityCode});
      this.companyFacilities =  await barcodeCompanyModuleState.getCompanyFacilities(this.currentCompany.id);
      notifications.success("Facility Added", "Successfully added facility");
      this.facilityCode = null;
      this.closeAddModal();
    } catch (ex) {
      notifications.error("Add Facility", "Failed to add facility", ex);
    } finally {
      this.loading = false;
    }
  }

  promptForRemoveFacility(facilityCode: string){
    this.facilityCode = facilityCode;
    this.promptDelete = true;
  }
  
  async manageManufacturers(company: CompanyListItem) {
    try {
      this.loading = true;
      this.companyManufacturers = null;
      this.currentCompany = company;     
      this.showManageManufacturers = true;
      this.companyManufacturers =  await barcodeCompanyModuleState.getCompanyManufacturers(this.currentCompany.id);
    } catch (ex) {
      notifications.error("Company Facilities", "Failed to load company facilities", ex);
      this.showManageManufacturers = false;
    } finally {
      this.loading = false;
    }
  }

  async removeManufacturer() {
    try {
      this.loading = true;
      await barcodeCompanyModuleState.removeCompanyManufacturer({id: this.currentCompany.id, manufacturerCode: this.manufacturerCode});
      this.companyManufacturers =  await barcodeCompanyModuleState.getCompanyManufacturers(this.currentCompany.id);
      notifications.success("Manufacturer Removed", "Successfully removed manufacturer");
      this.manufacturerCode = null;
      this.closeDeleteModal();
    } catch (ex) {
      notifications.error("Remove Manufacturer", "Failed to remove manufacturer", ex);
    } finally {
      this.loading = false;
    }
  }

  async addManufacturer() {
    try {
      this.loading = true;
      await barcodeCompanyModuleState.addCompanyManufacturer({id: this.currentCompany.id, manufacturerCode: this.manufacturerCode});
      this.companyManufacturers =  await barcodeCompanyModuleState.getCompanyManufacturers(this.currentCompany.id);
      notifications.success("Manufacturer Added", "Successfully added manufacturer");
      this.manufacturerCode = null;
      this.closeAddModal();
    } catch (ex) {
      notifications.error("Add Manufacturer", "Failed to add manufacturer", ex);
    } finally {
      this.loading = false;
    }
  }

  promptForRemoveManufacturer(manufacturerCode: string){
    this.manufacturerCode = manufacturerCode;
    this.promptDelete = true;
  }

  async manageItemTypes(company: CompanyListItem) {
    try {
      this.loading = true;
      this.companyItemTypes = null;
      this.currentCompany = company;     
      this.showManageItemTypes = true;
      this.companyItemTypes =  await barcodeCompanyModuleState.getCompanyItemTypes(this.currentCompany.id);
    } catch (ex) {
      notifications.error("Company Item Types", "Failed to load company item types", ex);
      this.showManageItemTypes = false;
    } finally {
      this.loading = false;
    }
  }  
  
  async removeItemType() {
    try {
      this.loading = true;
      await barcodeCompanyModuleState.removeCompanyItemType({id: this.currentCompany.id, itemTypeValue: this.itemTypeValue});
      this.companyItemTypes =  await barcodeCompanyModuleState.getCompanyItemTypes(this.currentCompany.id);
      notifications.success("Item Type Removed", "Successfully removed item type");
      this.itemTypeValue = null;
      this.closeDeleteModal();
    } catch (ex) {
      notifications.error("Remove Item Type", "Failed to remove item type", ex);
    } finally {
      this.loading = false;
    }
  }

  async addItemType() {
    try {
      this.loading = true;
      await barcodeCompanyModuleState.addCompanyItemType({id: this.currentCompany.id, itemTypeValue: this.itemTypeValue});
      this.companyItemTypes =  await barcodeCompanyModuleState.getCompanyItemTypes(this.currentCompany.id);
      notifications.success("Item Type Added", "Successfully added item type");
      this.manufacturerCode = null;
      this.closeAddModal();
    } catch (ex) {
      notifications.error("Add Item Type", "Failed to add item type", ex);
    } finally {
      this.loading = false;
    }
  }

  promptForRemoveItemType(itemTypeValue: string){
    this.itemTypeValue = itemTypeValue;
    this.promptDelete = true;
  }

  async manageBillTos(company: CompanyListItem) {
    try {
      this.loading = true;
      this.companyBillTos = null;
      this.currentCompany = company;     
      this.showManageBillTos = true;
      this.companyBillTos =  await barcodeCompanyModuleState.getCompanyBillTos(this.currentCompany.id);
    } catch (ex) {
      notifications.error("Company Bill Tos", "Failed to load company bill tos", ex);
      this.showManageBillTos = false;
    } finally {
      this.loading = false;
    }
  }

  async removeBillTo() {
    try {
      this.loading = true;
      await barcodeCompanyModuleState.removeCompanyBillTo({id: this.currentCompany.id, billToCompanyId: this.billToCompanyId});
      this.companyBillTos =  await barcodeCompanyModuleState.getCompanyBillTos(this.currentCompany.id);
      notifications.success("Bill To Removed", "Successfully removed bill to");
      this.billToCompanyId = null;
      this.closeDeleteModal();
    } catch (ex) {
      notifications.error("Remove Bill To", "Failed to remove bill to", ex);
    } finally {
      this.loading = false;
    }
  }

  async addBillTo() {
    try {
      this.loading = true;
      await barcodeCompanyModuleState.addCompanyBillTo({id: this.currentCompany.id, billToCompanyId: this.billToCompanyId});
      this.companyBillTos =  await barcodeCompanyModuleState.getCompanyBillTos(this.currentCompany.id);
      notifications.success("Bill To Added", "Successfully added bill to");
      this.billToCompanyId = null;
      this.closeAddModal();
    } catch (ex) {
      notifications.error("Add Bill To", "Failed to add bill to", ex);
    } finally {
      this.loading = false;
    }
  }

  promptForRemoveBillTo(billToCompanyId: string){
    this.billToCompanyId = billToCompanyId;
    this.promptDelete = true;
  }

  promptForDelete() {
    this.promptDelete = true;
  }

  openAddModal() {
    this.manufacturerCode = null;
    this.facilityCode = null;
    this.showAddModal = true;
  }

  closeDeleteModal() {
    this.promptDelete = false;
  }

  closeAddModal() {
    this.showAddModal = false;
  }

  closeEditCompanyModal() {
    this.promptDelete = false;
    this.editCompanyModel.visible = false;
    this.editCompanyModel = null;
  }

  async editCompany(item: CompanyListItem = null) {
    this.editCompanyModel = new EditBarcodeCompanyModel();
    this.editCompanyModel.visible = true;

    if (item) {
      const company = await barcodeCompanyModuleState.getCompany(item.id);
      this.editCompanyModel.loading = false;
      this.$set(this.editCompanyModel, 'id', company.id);
      this.$set(this.editCompanyModel, 'companyName', company.companyName);
      this.$set(this.editCompanyModel, 'requiresStaging', company.requiresStaging);
      this.$set(this.editCompanyModel, 'assignPalletLocationAfterReceiving', company.assignPalletLocationAfterReceiving);
      this.$set(this.editCompanyModel, 'requiresSignature', company.requiresSignature);
      this.$set(this.editCompanyModel, 'logOrderStatusChange', company.logOrderStatusChange);
      this.$set(this.editCompanyModel, 'enableReturns', company.enableReturns);
      this.$set(this.editCompanyModel, 'requiresPhoto', company.requiresPhoto);
      this.$set(this.editCompanyModel, 'useOrderGroupText2', company.useOrderGroupText2);
      this.$set(this.editCompanyModel, 'allowLoadReceiving', company.allowLoadReceiving);
      this.$set(this.editCompanyModel, 'allowManualNoScanItems', company.allowManualNoScanItems);
    } else {
      this.editCompanyModel.showForNewCompany();
    }
  }
}
